import { StoreState } from '@/core/models/store.interface';
import { ActionContext } from 'vuex';
import { Module } from './module.interface';
import { ModuleService } from './module.service';
import role, { RoleState } from './roles/role.store';
import user, { UserState } from './users/user.store';

const service = new ModuleService();

export interface ModuleState {
   user?: UserState;
   role?: RoleState;

   modules?: Array<Module>;
}

const state: ModuleState = {};

const getters = {
   modulesOverview(state: ModuleState) {
      return state.modules;
   },
};

const mutations = {
   SET_MODULES(state: ModuleState, modules: Array<Module>) {
      state.modules = modules;
   },
};

const actions = {
   async getModules(context: ActionContext<ModuleState, StoreState>) {
      const response = await service.getModules();
      context.commit('SET_MODULES', response);
      return response;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
   modules: {
      user,
      role,
   },
};
